import { Position } from 'reactflow';
import { applyVueInReact } from 'vuereact-combined';

import styles from './NodeTypes.module.scss';
import { HiddenHandle } from './common';
import { NodeProps } from '../types';
import FlowTreeBlockWrapper from '@/components/FlowTree/FlowTreeBlockWrapper.vue';
type NodePropsData = NodeProps['data'];
type LoopStartNodeProps = Omit<NodeProps, 'data'> & {
	data: Omit<NodePropsData, 'outgoingHandles'> & { outgoingHandles: NonNullable<NodePropsData['outgoingHandles']> };
};
const VueFlowTreeBlock = applyVueInReact(FlowTreeBlockWrapper);
export default function LoopStartNode({ data, sourcePosition = Position.Top, targetPosition = Position.Bottom }: LoopStartNodeProps) {
	const outgoingHandles = data.outgoingHandles;
	const outgoingHandleCount = outgoingHandles.length || 2;
	return (
		<div className={styles.centerizeSmallNode}>
			{Array.from({ length: outgoingHandleCount }).map((_, index) => (
				<HiddenHandle type="source" position={sourcePosition} id={outgoingHandles[index]} key={outgoingHandles[index]} />
			))}
			<VueFlowTreeBlock
				block={data.node}
				workflowVersionId={data.workflowVersionId}
				hasLoadedNodesData={data.hasLoadedNodesData}
				canAddContextualActionNode={data.canAddContextualActionNode}
			/>
			<HiddenHandle type="target" position={targetPosition} />
		</div>
	);
}
